module.exports = __webpack_public_path__ + "img/hero-06.43fe281e.jpg";